import { styled, Typography } from '@mui/material';

export const PolicyFooterContent = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[800],
  textAlign: 'center',
  [theme.breakpoints.up('lg')]: {
    textAlign: 'left',
  },
}));
